import { IMatter } from './matter';
import { IPrincipalCompany } from './principalCompany';
import { IPrincipalPrivatePerson } from './principalPrivatePerson';
import { ITask } from './tasks';
import { ITransaction } from './transaction';
import { ITranslations } from './transactionTypes';
import { IUser } from './user';

export interface IWorkTime {
  createdOn: string;
  modifiedOn: string;
  createdById: string;
  modifiedById: string;
  createdBySource: string;
  modifiedBySource: string;
  version: string;
  revision: number;
  id: string;
  subject: string;
  startTime: string;
  endTime: string;
  duration: number;
  description: string;
  matterId: string;
  activityId: string;
  transactionId: string;
  companyId: string;
  privatePersonId: string;
  skillId: string;
  matterPhaseId: string;
  workTimeUserId: string;
  workTimeTypeId: string;
  workTimeType: IWorkTimeType;
  transaction: ITransaction;
  matter: IMatter;
  activity: ITask;
  workTimeUser: IUser;
  company: IPrincipalCompany;
  privatePerson: IPrincipalPrivatePerson;
  isEditingForDragableCreate?: boolean;
  isSubjectManuallyEdited?: boolean;
  isWorkTimeTypeManuallyCleared?: boolean;
}
export interface IWorkTimeType {
  createdOn: string;
  modifiedOn: string;
  createdById: string;
  modifiedById: string;
  createdBySource: string;
  modifiedBySource: string;
  version: string;
  revision: string;
  id: string;
  translations: ITranslations[];
  status: string;
  description: string;
  system: boolean;
  color: string;
}
export enum WorkTimeTab {
  calendar = 'calendar',
  agenda = 'agenda',
}
export interface IGroupedWorkTimes {
  date: string;
  amount: number;
  totalDuration: { value: string; unit: 'hours' | 'minutes' };
  workTimes: { workTime: IWorkTime; currentOfTotalDays?: string }[];
}
export interface ICreateWorkTimeDto {
  subject: string;
  startTime: string;
  endTime: string;
  description?: string;
  matterId?: string | null;
  activityId?: string | null;
  transactionId?: string;
  skillId?: string;
  matterPhaseId?: string;
  workTimeUserId: string;
  workTimeTypeId?: string;
  version?: string;
  id?: string;
}

export type IUpdateWorkTimeDto = Partial<ICreateWorkTimeDto>;
export enum WorkTimeFilters {
  MY = 'my',
  OTHER = 'other',
}
